import React from 'react';
import type { Team } from '../../../../types';

interface TeamInfoProps {
  team: Team;
  memberCount: number;
}

export const TeamInfo: React.FC<TeamInfoProps> = ({ team, memberCount }) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-3 border border-blue-100">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center mb-1.5">
            <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center text-white font-semibold text-sm mr-3">
              {team.name.charAt(0).toUpperCase()}
            </div>
            <div>
              <h3 className="text-base font-semibold text-gray-900">{team.name}</h3>
              {team.description && (
                <p className="text-sm text-gray-600 mt-1">{team.description}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <div className="grid grid-cols-3 gap-3 mt-3">
        <div className="text-center">
          <div className="flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full mx-auto mb-1">
            <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div className="text-base font-semibold text-gray-900">{memberCount}</div>
          <div className="text-xs text-gray-500">成员</div>
        </div>
        
        <div className="text-center">
          <div className="flex items-center justify-center w-6 h-6 bg-green-100 rounded-full mx-auto mb-1">
            <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a4 4 0 118 0v4m-4 8a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div className="text-base font-semibold text-gray-900">{team.inviteCode.length}</div>
          <div className="text-xs text-gray-500">位邀请码</div>
        </div>
        
        <div className="text-center">
          <div className="flex items-center justify-center w-6 h-6 bg-purple-100 rounded-full mx-auto mb-1">
            <svg className="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a4 4 0 118 0v4m-4 8a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div className="text-base font-semibold text-gray-900">
            {Math.floor((Date.now() - new Date(team.createdAt).getTime()) / (1000 * 60 * 60 * 24))}
          </div>
          <div className="text-xs text-gray-500">天</div>
        </div>
      </div>
      
      <div className="flex items-center justify-between mt-3 pt-3 border-t border-blue-200">
        <div className="flex items-center text-sm text-gray-600">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a4 4 0 118 0v4m-4 8a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          创建于 {formatDate(team.createdAt)}
        </div>
        
        <div className="flex items-center text-sm text-blue-600">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          活跃团队
        </div>
      </div>
    </div>
  );
};